// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import Routes from './routes'
import VueMarqueeSlider from 'vue-marquee-slider'

// import '@/assets/styles/boolland.scss';

Vue.use(VueRouter)
Vue.use(VueMarqueeSlider)

const router = new VueRouter({
  mode: 'history',
  routes: Routes
})

new Vue({
  el: '#app',
  router,
  data: {
    lenis: null
  },
  mounted() {
    if (window.Lenis) {
      this.lenis = new window.Lenis({
        duration: 1.2,
        lerp: 0.1,
        smoothWheel: true
      });

      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;

      if (gsap && ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);

        // 🔥 Sync ScrollTrigger with Lenis
        this.lenis.on('scroll', ScrollTrigger.update);
      }

      const raf = (time) => {
        this.lenis.raf(time);
        requestAnimationFrame(raf);
      };
      requestAnimationFrame(raf);
    }
  },
  watch: {
    '$route'() {
      if (this.lenis) {
        this.lenis.scrollTo(0, { immediate: true });
      }
    }
  },
  render: h => h('router-view')
})


// WEBPACK FOOTER //
// ./src/main.js